import {
  Autocomplete,
  Box,
  Grid,
  TextField,
  Checkbox,
  Chip,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ButtonComponent from "../../Components/Common/button/Button";
import {
  ENVIRONMENT_OPTIONS,
  REQUEST_TYPE_OPTIONS,
  RESQUEST_TYPE_WITH_ALL_OPTIONS,
  AD_ROLE_OPTIONS,
  AD_PROCESS_TYPE_OPTIONS,
} from "./AccessConstants";
import ApiService from "../../utils/fetch";
import { useSelector } from "react-redux";
import { MessagePopup } from "../../Components/Common/messagePopup/MessagePopup";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DownloadIcon from "@mui/icons-material/Download";
import { set } from "lodash";

function AccessRequest() {
  const BottlerData = useSelector((state) => state.user.userData);

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // Form state variables
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [environment, setEnvironment] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [userKoId, setUserKoId] = useState("");
  const [requestTypeList, setRequestTypeList] = useState([]);
  const [IBPRole, setIBPRole] = useState(null);
  const [permissionFilter, setPermissionFilter] = useState(null);
  const [permissionFilterList, setPermissionFilterList] = useState([]);
  const [permissionFilterInput, setPermissionFilterInput] = useState("");
  const [bottlerList, setBottlerList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [adGroupRole, setAdGroupRole] = useState(null);
  const [adProcessType, setAdProcessType] = useState(null);

  // Individual flags
  const [isAutonomous, setIsAutonomous] = useState(false);
  const [isIBP, setIsIBP] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  // Options state
  const [permissionFilterOptions, setPermissionFilterOptions] = useState([]);
  const [IBPRoleOptions, setIBPRoleOptions] = useState([]);
  const [bottlerOptions, setBottlerOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [plantOptions, setPlantOptions] = useState([]);

  //All Options state
  const [bottlerOptionsWithAllOptions, setBottlerOptionsWithAllOptions] =
    useState([]);
  const [countryOptionsWithAllOptions, setCountryOptionsWithAllOptions] =
    useState([]);
  const [customerOptionsWithAllOptions, setCustomerOptionsWithAllOptions] =
    useState([]);
  const [plantOptionsWithAllOptions, setPlantOptionsWithAllOptions] = useState(
    [],
  );

  // whole Options List
  const [wholeBottlerOptionList, setWholeBottlerOptionList] = useState([]);
  const [wholeCountryOptionList, setWholeCountryOptionList] = useState([]);
  const [wholeCustomerOptionList, setWholeCustomerOptionList] = useState([]);
  const [wholePlantOptionList, setWholePlantOptionList] = useState([]);
  /**
   * API call Methods
   */

  // Fetch First & Last Name by Email
  const fetchNameByEmail = async (emailValue) => {
    if (!emailValue || !emailRegex.test(emailValue)) return;

    try {
      const response = await ApiService.get(
        `/v1/access-ticket/fetch-user-name?email=${encodeURIComponent(emailValue)}`,
      );

      if (response?.data) {
        setFirstName(response.data.givenName || "");
        setLastName(response.data.surname || "");
      }
    } catch (error) {
      setFirstName("");
      setLastName("");
      const backendMessage =
        error?.response?.data?.message || "Failed to Update User Name";
      MessagePopup({
        icon: "error",
        title: "Error",
        message: backendMessage,
      });
    }
  };

  // Fetch IBP Business Roles
  const fetchIBPRoles = async () => {
    try {
      const response = await ApiService.get(`/v1/ibp/business-roles`);
      setIBPRoleOptions(response.data || []);
      // setPermissionFilterOptions(permissionFilters);
    } catch (error) {
      console.error("Failed to fetch ticket details:", error);
      setIBPRoleOptions([]);
    }
  };

  // Fetch Permission Filters based on selected IBP Role
  const fetchPermissionFiltersByRole = async (businessRole) => {
    if (!businessRole) {
      setPermissionFilterOptions([]);
      return;
    }

    try {
      const response = await ApiService.post(
        `/v1/ibp/fetch-roles-by-types?businessRole=${businessRole}`,
      );
      const filters = response.data || [];
      const mapped = filters.map((item) => ({
        roleName: item.roleName,
        bottler: item.permissionScope,
      }));

      setPermissionFilterOptions(mapped);
    } catch (error) {
      console.error("Failed to fetch permission filters:", error);
      setPermissionFilterOptions([]);
    }
  };

  // Fetch Bottlers
  const fetchBottlers = async () => {
    try {
      const res = await ApiService.get(
        "/v1/access-ticket/bottler-entitled",
        {},
      );
      const opts = res.data.map((b) => ({
        id: b.bottler,
        label: b.bottler,
        country: b.country,
      }));
      setWholeBottlerOptionList(opts);
      setBottlerOptions(opts);
      setBottlerOptionsWithAllOptions([
        {
          id: "select-all-bottler",
          label: "All",
          isSelectAll: true,
        },
        ...opts,
      ]);
    } catch (err) {
      console.error("Failed to load bottlers", err);
      setBottlerOptions([]);
      setWholeBottlerOptionList([]);
      setBottlerOptionsWithAllOptions([]);
    }
  };

  // Fetch Countries
  const fetchCountries = async (filters = {}) => {
    try {
      const res = await ApiService.post(
        "/v1/access-ticket/active-country",
        filters,
      );

      const countryMap = new Map();

      res.data.forEach((item) => {
        const country = item.country;
        const bottlers = Array.isArray(item.bottler)
          ? item.bottler
          : [item.bottler];

        if (!countryMap.has(country)) {
          countryMap.set(country, new Set());
        }
        bottlers.forEach((b) => countryMap.get(country).add(b));
      });

      const opts = Array.from(countryMap.entries()).map(
        ([country, bottlerSet]) => ({
          id: country,
          label: country,
          country: country,
          bottlers: Array.from(bottlerSet),
        }),
      );

      setCountryOptions(opts);
      setWholeCountryOptionList(opts);
      setCountryOptionsWithAllOptions([
        {
          id: "select-all-country",
          label: "All",
          isSelectAll: true,
        },
        ...opts,
      ]);
    } catch (err) {
      console.error("Failed to load countries", err);
      setCountryOptions([]);
      setWholeCountryOptionList([]);
      setCountryOptionsWithAllOptions([]);
    }
  };

  // Fetch Customers
  const fetchCustomers = async (filters = {}) => {
    try {
      const res = await ApiService.post(
        "/v1/access-ticket/active-customer-selection-by-bottler",
        filters,
      );

      const customerMap = new Map();

      res.data.forEach((c) => {
        const id = c.customerId;
        if (!customerMap.has(id)) {
          customerMap.set(id, {
            id: id,
            label: `${id}-${c.customerName}-${c.customerCountry}`,
            customerId: id,
            customerName: c.customerName,
            combinations: [],
          });
        }
        customerMap.get(id).combinations.push({
          country: c.country,
          bottler: c.bottler,
        });
      });

      const opts = Array.from(customerMap.values());
      setCustomerOptions(opts);
      setWholeCustomerOptionList(opts);
      setCustomerOptionsWithAllOptions([
        {
          id: "select-all-customer",
          label: "All",
          isSelectAll: true,
        },
        ...opts,
      ]);
    } catch (err) {
      console.error("Failed to load customers", err);
      setCustomerOptions([]);
      setWholeCustomerOptionList([]);
      setCustomerOptionsWithAllOptions([]);
    }
  };

  //Fetch Plants
  const fetchPlants = async (filters = {}) => {
    try {
      const res = await ApiService.post(
        "/v1/access-ticket/active-location-selection-by-customer",
        filters,
      );

      // Group by plantId
      const plantMap = new Map();

      res.data.forEach((p) => {
        const key = p.plantId;
        if (!plantMap.has(key)) {
          plantMap.set(key, {
            plantId: p.plantId,
            plantName: p.plantName,
            combinations: [],
          });
        }
        plantMap.get(key).combinations.push({
          customerId: p.customerId,
          customerName: p.customerName,
          country: p.country,
          bottler: p.bottler,
        });
      });

      const opts = Array.from(plantMap.values()).map((plant) => {
        const display = `${plant.plantId}-${plant.plantName}`;

        return {
          id: plant.plantId,
          label: display,
          plantId: plant.plantId,
          plantName: plant.plantName,
          combinations: plant.combinations,
        };
      });

      setPlantOptions(opts);
      setWholePlantOptionList(opts);
      setPlantOptionsWithAllOptions([
        {
          id: "select-all-plant",
          label: "All",
          isSelectAll: true,
        },
        ...opts,
      ]);
    } catch (err) {
      console.error("Failed to load plants", err);
      setPlantOptions([]);
      setWholePlantOptionList([]);
      setPlantOptionsWithAllOptions([]);
    }
  };

  /**
   * Memo Variables
   */
  const sortedOptions = React.useMemo(() => {
    return [...permissionFilterOptions].sort((a, b) => {
      if (a.bottler !== b.bottler) return a.bottler.localeCompare(b.bottler);
      return a.roleName.localeCompare(b.roleName);
    });
  }, [permissionFilterOptions]);

  const permissionOptionsWithAll = React.useMemo(
    () => [
      { roleName: "Select All", bottler: "", isSelectAll: true }, // Clearer label
      ...sortedOptions,
    ],
    [sortedOptions],
  );

  /**
   * Methods
   */

  //Handle clear form
  const handleClear = () => {
    clearCommonFields();
    clearAutonomousDependentFields();
    clearIBPDependentFields();
  };

  //clear common fields
  const clearCommonFields = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setEnvironment(null);
    setRemarks("");
    setRequestTypeList([]);
    setIsAutonomous(false);
    setIsIBP(false);
    setIsSubmitting(false);
    setIsUploading(false);
  };

  //clear autonomous dependent fields
  const clearAutonomousDependentFields = () => {
    setBottlerList([]);
    setCountryList([]);
    setCustomerList([]);
    setPlantList([]);
    setAdGroupRole(null);
    setAdProcessType(null);

    //Reset Options
    setBottlerOptions(wholeBottlerOptionList);
    setCountryOptions(wholeCountryOptionList);
    setCustomerOptions(wholeCustomerOptionList);
    setPlantOptions(wholePlantOptionList);

    setBottlerOptionsWithAllOptions([
      {
        id: "select-all-bottler",
        label: "All",
        isSelectAll: true,
      },
      ...wholeBottlerOptionList,
    ]);
    setCountryOptionsWithAllOptions([
      {
        id: "select-all-country",
        label: "All",
        isSelectAll: true,
      },
      ...wholeCountryOptionList,
    ]);
    setCustomerOptionsWithAllOptions([
      {
        id: "select-all-customer",
        label: "All",
        isSelectAll: true,
      },
      ...wholeCustomerOptionList,
    ]);
    setPlantOptionsWithAllOptions([
      {
        id: "select-all-plant",
        label: "All",
        isSelectAll: true,
      },
      ...wholePlantOptionList,
    ]);
  };

  //clear IBP dependent fields
  const clearIBPDependentFields = () => {
    // setUserKoId("");
    setIBPRole(null);
    setPermissionFilter(null);
    setPermissionFilterList([]);
    //Reset Options
    setPermissionFilterOptions([]);
  };

  // Handle form submission
  const handleSubmit = async () => {
    //handle multiple clicks
    if (isSubmitting) return;

    //validate form data
    var missing = validateFormData();

    if (missing.length > 0) {
      MessagePopup({
        icon: "error",
        title: "Missing Required Fields",
        message: `Please complete: ${missing.join(", ")}`,
      });
      return;
    }
    if (!emailRegex.test(email)) {
      MessagePopup({
        icon: "error",
        title: "Invalid Email",
        message: "Please enter a valid Requester Email.",
      });
      return;
    }
    setIsSubmitting(true);
    await processDataSubmission();
  };

  //validate form data
  const validateFormData = () => {
    const missing = [];

    if (!requestTypeList || requestTypeList.length === 0)
      missing.push("Request Type");
    if (!environment) missing.push("Environment");
    if (!remarks) missing.push("Business Justification");
    if (!firstName) missing.push("First Name");
    if (!lastName) missing.push("Last Name");
    if (!email) missing.push("Requester Email");

    // Autonomous-specific required
    if (isAutonomous) {
      if (!adGroupRole) missing.push("AD Group Role");
      if (!adProcessType) missing.push("AD Process Type");
      if (!bottlerList || bottlerList.length === 0) missing.push("Bottler");
      if (!customerList || customerList.length === 0) missing.push("Customer");
      if (!plantList || plantList.length === 0) missing.push("Plant");
    }

    // IBP-specific required
    if (isIBP) {
      if (!permissionFilter) missing.push("Permission Filter");
      if (!IBPRole) missing.push("IBP Business Role");
      // if (!userKoId) missing.push("Requester Ko Id");
    }

    return missing;
  };
  const processDataSubmission = async () => {
    const groupedData = groupPlantsByBottlerCustomer();
    try {
      const requestBody = {
        requestType: requestTypeList.map((requestType) => requestType.label),
        requestedRole: adGroupRole ? [adGroupRole] : [],
        permissionFilter: permissionFilterList
          ? permissionFilterList.map((item) => item.roleName)
          : [],
        businessRole: IBPRole ? [IBPRole] : [],
        process: adProcessType || "",
        firstName,
        lastName,
        requesterEmail: email,
        raisedBy: BottlerData.emailId || null,
        environment,
        businessJustification: remarks || "",
        requestBykoId: null,
        requestForkoId: null,
        selectedData: groupedData,
      };

      const response = await ApiService.post(
        "/v1/access-ticket/manage-access",
        requestBody,
      );

      if (response.status === 200) {
        MessagePopup({
          icon: "success",
          title: "Success!",
          message: "Submitted!",
        });
        handleClear();
      }
    } catch (error) {
      MessagePopup({
        icon: "error",
        title: "Error",
        message: "Failed. Try again.",
      });
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  //group plants by bottler and customer
  // const groupPlantsByBottlerCustomer = () => {
  //   if (!plantList || plantList.length === 0) return [];

  //   const grouped = new Map();

  //   plantList.forEach((plant) => {
  //     plant.combinations.forEach((combo) => {
  //       const key = `${combo.bottler}|${combo.customerId}`;
  //       if (!grouped.has(key)) {
  //         grouped.set(key, {
  //           Bottler: combo.bottler,
  //           customer: combo.customerId,
  //           PlantIds: [],
  //         });
  //       }
  //       const entry = grouped.get(key);
  //       if (!entry.PlantIds.includes(plant.plantId)) {
  //         entry.PlantIds.push(plant.plantId);
  //       }
  //     });
  //   });

  //   return Array.from(grouped.values());
  // };

  const groupPlantsByBottlerCustomer = () => {
    if (!plantList || plantList.length === 0) return [];

    const grouped = new Map();

    plantList.forEach((plant) => {
      // Filter combinations to only those that match currently selected filters
      const relevantCombinations = plant.combinations.filter((combo) => {
        const bottlerMatch =
          bottlerList.length === 0 ||
          bottlerList.some((b) => b.id === combo.bottler);

        const customerMatch =
          customerList.length === 0 ||
          customerList.some((c) => c.customerId === combo.customerId);

        const countryMatch =
          countryList.length === 0 ||
          countryList.some((c) => c.id === combo.country);

        return bottlerMatch && customerMatch && countryMatch;
      });

      relevantCombinations.forEach((combo) => {
        const key = `${combo.bottler}|${combo.customerId}`;

        if (!grouped.has(key)) {
          grouped.set(key, {
            Bottler: combo.bottler,
            customer: combo.customerId,
            PlantIds: [],
          });
        }

        const entry = grouped.get(key);
        if (!entry.PlantIds.includes(plant.plantId)) {
          entry.PlantIds.push(plant.plantId);
        }
      });
    });

    return Array.from(grouped.values());
  };

  /**
   * Upload & Download Handlers
   */
  const DownloadTemplate = async (e) => {
    e.preventDefault();

    setLoading(true);
    const groupedData = groupPlantsByBottlerCustomer();

    const payloadData = {
      requestType: requestTypeList.map((requestType) => requestType.label),
      requestedRole: adGroupRole ? [adGroupRole] : [],
      permissionFilter: permissionFilterList
        ? permissionFilterList.map((item) => item.roleName)
        : [],
      businessRole: IBPRole ? [IBPRole] : [],
      process: adProcessType || "",
      firstName,
      lastName,
      requesterEmail: email,
      raisedBy: BottlerData.emailId || null,
      environment,
      businessJustification: remarks || "",
      requestBykoId: null,
      requestForkoId: null,
      selectedData: groupedData,
    };

    try {
      const response = await ApiService.downloadFile(
        "/v1/access-ticket/download-template",
        payloadData,
      );
      if (response.status === 200 && response.data) {
        const url = window.URL.createObjectURL(response.data);

        const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");

        const filename = `AccessTemplate_${timestamp}1.xlsx`;

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);

        MessagePopup({
          icon: "success",
          message: "Excel file downloaded successfully!",
        });
      }
    } catch (error) {
      const errorMessage = "Failed to Download file.";
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: errorMessage,
      });
      setIsSubmitting(false);
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (event) => {
    if (isUploading) return;

    const selectedFile = event.target.files[0];
    if (!selectedFile) {
      MessagePopup({
        icon: "error",
        title: "Error!",
        message: "Please select a file!",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setIsUploading(true);

    MessagePopup({
      title: "Confirm Submission of Bulk Upload",
      html: `<p>Are you sure you want to submit the
                   <p>File selected: ${selectedFile.name} </p>`,
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#000000",
      cancelButtonColor: "#808080",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await ApiService.uploadAndDownload(
            "/v1/access-ticket/validate-and-process-access-upload",
            formData,
          );

          const validationResult = response.headers?.["x-validation-result"];

          if (validationResult === "SUCCESS") {
            MessagePopup({
              icon: "success",
              title: "Upload Completed",
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else if (validationResult === "FAILED") {
            const url = window.URL.createObjectURL(response.data);

            const timestamp = new Date().toISOString().replace(/[-T:.Z]/g, "_");

            const filename = `AccessRequest_ErrorReport_${timestamp}1.xlsx`;

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);

            MessagePopup({
              icon: "error",
              title: "Upload Failed",
              html: `<p class="red-text"> Multiple errors found in the uploaded file. A report has been downloaded for your review </p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          } else {
            MessagePopup({
              icon: "error",
              title: "Upload Failed",
              html: `<p class="red-text"> Error While Processing the Upload </p>`,
              confirmButtonText: "Ok",
              confirmButtonColor: "#000000",
            });
          }
        } catch (error) {
          console.log(error);
          let text = "Error While Processing the upload";
          if (error.response.data instanceof Blob) {
            text = await error.response.data.text();
          }
          MessagePopup({
            icon: "error",
            title: "Upload Failed",
            html: `<p class="red-text"> ${text} </p>`,
            confirmButtonText: "Ok",
            confirmButtonColor: "#000000",
          });
        } finally {
          setIsUploading(false);
        }
      } else {
        setIsUploading(false);
      }
    });
  };

  /**
   *  onChange handler Methods
   */

  // Request Type onChange handler
  const requestTypeOnChangeHandler = (e, newValue) => {
    const clickedAll = newValue.some((o) => o.isSelectAll);

    let nextSelected = [];

    if (clickedAll) {
      // Toggle ALL
      const allAlreadySelected =
        requestTypeList.length === REQUEST_TYPE_OPTIONS.length;

      nextSelected = allAlreadySelected ? [] : REQUEST_TYPE_OPTIONS;
    } else {
      // Remove "All" if present and deduplicate by id
      const unique = new Map();
      (newValue || []).forEach((o) => {
        if (!o.isSelectAll && o.id) {
          unique.set(o.id, o);
        }
      });
      nextSelected = Array.from(unique.values());

      // If user selects all real options manually, mark as all
      if (nextSelected.length === REQUEST_TYPE_OPTIONS.length) {
        nextSelected = REQUEST_TYPE_OPTIONS;
      }
    }

    setRequestTypeList(nextSelected);

    const selectedIds = nextSelected.map((o) => o.id);
    const isAutonomousSelected = selectedIds.includes("autonomous");
    const isIBPSelected = selectedIds.includes("ibp");
    setIsAutonomous(isAutonomousSelected);
    setIsIBP(isIBPSelected);

    if (!isAutonomousSelected) {
      clearAutonomousDependentFields();
    }

    if (!isIBPSelected) {
      clearIBPDependentFields();
    }
  };

  //IBP Role onChange handler
  const ibpRoleOnChangeHandler = (e, role) => {
    setIBPRole(role);

    // If role is cleared (null), fully reset Permission Filter
    if (!role) {
      setPermissionFilter(null);
      setPermissionFilterList([]);
      setPermissionFilterInput("");
      setPermissionFilterOptions([]); // Clear options too
    } else {
      // Only fetch new filters if a valid role is selected
      fetchPermissionFiltersByRole(role);
    }
  };

  //Bottler onChange handler
  const bottlerOnChangeHandler = (e, newValue) => {
    const clickedAll = newValue.some((o) => o.isSelectAll);

    let nextSelected = [];

    if (clickedAll) {
      // Toggle ALL
      const allAlreadySelected = bottlerList.length === bottlerOptions.length;

      nextSelected = allAlreadySelected ? [] : bottlerOptions;
    } else {
      // Remove "All" if present
      nextSelected = newValue.filter((o) => !o.isSelectAll);

      // If user selects all real options manually
      if (nextSelected.length === bottlerOptions.length) {
        nextSelected = bottlerOptions;
      }
    }

    setBottlerList(nextSelected);
    applyFilters({
      source: "bottler",
      bottlerList: nextSelected,
      countryList,
      customerList,
      plantList,
    });
  };

  //Country onChange handler
  const countryOnChangeHandler = (e, newValue) => {
    const clickedAll = newValue.some((o) => o.isSelectAll);

    let nextSelected = [];

    if (clickedAll) {
      // Toggle ALL
      const allAlreadySelected = countryList.length === countryOptions.length;

      nextSelected = allAlreadySelected ? [] : countryOptions;
    } else {
      // Remove "All" if present
      nextSelected = newValue.filter((o) => !o.isSelectAll);

      // If user selects all real options manually
      if (nextSelected.length === countryOptions.length) {
        nextSelected = countryOptions;
      }
    }

    setCountryList(nextSelected);
    applyFilters({
      source: "country",
      bottlerList,
      countryList: nextSelected,
      customerList,
      plantList,
    });
  };

  //Customer onChange handler
  const customerOnChangeHandler = (e, newValue) => {
    const clickedAll = newValue.some((o) => o.isSelectAll);

    let nextSelected = [];

    if (clickedAll) {
      // Toggle ALL
      const allAlreadySelected = customerList.length === customerOptions.length;

      nextSelected = allAlreadySelected ? [] : customerOptions;
    } else {
      // Remove "All" if present
      nextSelected = newValue.filter((o) => !o.isSelectAll);

      // If user selects all real options manually
      if (nextSelected.length === customerOptions.length) {
        nextSelected = customerOptions;
      }
    }

    setCustomerList(nextSelected);
    applyFilters({
      source: "customer",
      bottlerList,
      countryList,
      customerList: nextSelected,
      plantList,
    });
  };

  //Plant onChange handler
  const plantOnChangeHandler = (e, newValue) => {
    const clickedAll = newValue.some((o) => o.isSelectAll);

    let nextSelected = [];

    if (clickedAll) {
      // Toggle ALL
      const allAlreadySelected = plantList.length === plantOptions.length;

      nextSelected = allAlreadySelected ? [] : plantOptions;
    } else {
      // Remove "All" if present
      nextSelected = newValue.filter((o) => !o.isSelectAll);

      // If user selects all real options manually
      if (nextSelected.length === plantOptions.length) {
        nextSelected = plantOptions;
      }
    }

    setPlantList(nextSelected);
    applyFilters({
      source: "plant",
      bottlerList,
      countryList,
      customerList,
      plantList: nextSelected,
    });
  };

  const applyFilters = ({
    source,
    bottlerList,
    countryList,
    customerList,
    plantList,
  }) => {
    const bottlerAll = !bottlerList.length;
    const countryAll = !countryList.length;
    const customerAll = !customerList.length;
    const plantAll = !plantList.length;

    const selectedBottlers = bottlerAll ? [] : bottlerList.map((b) => b.id);
    const selectedCountries = countryAll ? [] : countryList.map((c) => c.id);
    const selectedCustomers = customerAll
      ? []
      : customerList.map((c) => c.customerId);
    const selectedPlants = plantAll ? [] : plantList.map((p) => p.plantId);

    // ---------------- Bottler ----------------
    if (source !== "bottler") {
      const filtered = wholeBottlerOptionList.filter((b) => {
        const validCountries = selectedCountries.length
          ? wholeCountryOptionList.some(
              (c) =>
                c.bottlers.includes(b.id) && selectedCountries.includes(c.id),
            )
          : true;
        const validCustomers = selectedCustomers.length
          ? wholeCustomerOptionList.some((c) =>
              c.combinations.some(
                (cb) =>
                  selectedCustomers.includes(c.customerId) &&
                  cb.bottler === b.id,
              ),
            )
          : true;
        const validPlants = selectedPlants.length
          ? wholePlantOptionList.some((p) =>
              p.combinations.some(
                (cb) =>
                  selectedPlants.includes(p.plantId) && cb.bottler === b.id,
              ),
            )
          : true;

        return validCountries && validCustomers && validPlants;
      });

      setBottlerOptions(filtered);
      setBottlerOptionsWithAllOptions([
        { id: "select-all-bottler", label: "All", isSelectAll: true },
        ...filtered,
      ]);
      setBottlerList((prevSelected) =>
        prevSelected.filter((selected) =>
          filtered.some((option) => option.id === selected.id),
        ),
      );
    }

    // ---------------- Country ----------------
    if (source !== "country") {
      const filtered = wholeCountryOptionList.filter((c) => {
        const validBottlers = selectedBottlers.length
          ? c.bottlers.some((b) => selectedBottlers.includes(b))
          : true;
        const validCustomers = selectedCustomers.length
          ? wholeCustomerOptionList.some((cust) =>
              cust.combinations.some(
                (cb) =>
                  selectedCustomers.includes(cust.customerId) &&
                  cb.country === c.id,
              ),
            )
          : true;
        const validPlants = selectedPlants.length
          ? wholePlantOptionList.some((p) =>
              p.combinations.some(
                (cb) =>
                  selectedPlants.includes(p.plantId) && cb.country === c.id,
              ),
            )
          : true;

        return validBottlers && validCustomers && validPlants;
      });

      setCountryOptions(filtered);
      setCountryOptionsWithAllOptions([
        { id: "select-all-country", label: "All", isSelectAll: true },
        ...filtered,
      ]);
      setCountryList((prevSelected) =>
        prevSelected.filter((selected) =>
          filtered.some((option) => option.id === selected.id),
        ),
      );
    }

    // ---------------- Customer ----------------
    if (source !== "customer") {
      const filtered = wholeCustomerOptionList.filter((c) => {
        const validBottlers = selectedBottlers.length
          ? c.combinations.some((cb) => selectedBottlers.includes(cb.bottler))
          : true;
        const validCountries = selectedCountries.length
          ? c.combinations.some((cb) => selectedCountries.includes(cb.country))
          : true;
        const validPlants = selectedPlants.length
          ? wholePlantOptionList.some((p) =>
              p.combinations.some(
                (cb) =>
                  selectedPlants.includes(p.plantId) &&
                  cb.customerId === c.customerId,
              ),
            )
          : true;

        return validBottlers && validCountries && validPlants;
      });

      setCustomerOptions(filtered);
      setCustomerOptionsWithAllOptions([
        { id: "select-all-customer", label: "All", isSelectAll: true },
        ...filtered,
      ]);
      setCustomerList((prevSelected) =>
        prevSelected.filter((selected) =>
          filtered.some((option) => option.id === selected.id),
        ),
      );
    }

    // ---------------- Plant ----------------
    if (source !== "plant") {
      const filtered = wholePlantOptionList.filter((p) => {
        const validBottlers = selectedBottlers.length
          ? p.combinations.some((cb) => selectedBottlers.includes(cb.bottler))
          : true;
        const validCountries = selectedCountries.length
          ? p.combinations.some((cb) => selectedCountries.includes(cb.country))
          : true;
        const validCustomers = selectedCustomers.length
          ? p.combinations.some((cb) =>
              selectedCustomers.includes(cb.customerId),
            )
          : true;

        return validBottlers && validCountries && validCustomers;
      });

      setPlantOptions(filtered);
      setPlantOptionsWithAllOptions([
        { id: "select-all-plant", label: "All", isSelectAll: true },
        ...filtered,
      ]);
      setPlantList((prevSelected) =>
        prevSelected.filter((selected) =>
          filtered.some((option) => option.id === selected.id),
        ),
      );
    }
  };

  /**
   * UseEffect Hooks
   */

  //initial data fetch
  useEffect(() => {
    fetchBottlers();
    fetchCountries();
    fetchCustomers();
    fetchPlants();
    fetchIBPRoles();
  }, []);

  return (
    <>
      <Box
        sx={{ p: 3, border: "1px solid #e0e0e0", borderRadius: "8px", m: 1 }}
      >
        {/* Row 1 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* Email ID */}
          {/* Email ID */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              size="small"
              fullWidth
              label="Email ID*"
              type="email"
              value={email}
              onChange={(e) => {
                const newEmail = e.target.value;
                setEmail(newEmail);
                if (newEmail.trim() === "") {
                  setFirstName("");
                  setLastName("");
                }
              }}
              onBlur={(e) => {
                const emailValue = e.target.value.trim();
                if (emailValue) {
                  fetchNameByEmail(emailValue);
                } else {
                  setFirstName("");
                  setLastName("");
                }
              }}
              sx={{ "& .MuiInputBase-root": { height: 37.5 } }}
              InputLabelProps={{
                shrink: true,
                style: { transform: "translate(14px, -14px) scale(0.75)" },
              }}
            />
          </Grid>
          {/* First Name */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              size="small"
              fullWidth
              label="First Name*"
              value={firstName}
              disabled={true}
              onChange={(e) => setFirstName(e.target.value)}
              sx={{ "& .MuiInputBase-root": { height: 37.5 } }}
              InputLabelProps={{
                shrink: true,
                style: { transform: "translate(14px, -14px) scale(0.75)" },
              }}
            />
          </Grid>
          {/* Last Name */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              size="small"
              fullWidth
              label="Last Name*"
              value={lastName}
              disabled={true}
              onChange={(e) => setLastName(e.target.value)}
              sx={{ "& .MuiInputBase-root": { height: 37.5 } }}
              InputLabelProps={{
                shrink: true,
                style: { transform: "translate(14px, -14px) scale(0.75)" },
              }}
            />
          </Grid>

          {/* Environment */}
          <Grid item xs={12} sm={6} md={3}>
            <Autocomplete
              disablePortal
              options={ENVIRONMENT_OPTIONS}
              size="small"
              value={environment}
              onChange={(e, v) => setEnvironment(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Environment*"
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Row 2 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* Business Justification */}
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              size="small"
              fullWidth
              label="Business Justification*"
              multiline
              rows={1}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              sx={{ "& .MuiInputBase-root": { height: 37.5 } }}
              InputLabelProps={{
                shrink: true,
                style: { transform: "translate(14px, -14px) scale(0.75)" },
              }}
            />
          </Grid>
          {/* Request Type */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              limitTags={1}
              options={RESQUEST_TYPE_WITH_ALL_OPTIONS}
              disableCloseOnSelect
              value={requestTypeList}
              onChange={requestTypeOnChangeHandler}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option, { selected }) => {
                const { key, ...liProps } = props;

                const isSelectAll = option?.isSelectAll === true;

                let checked;
                if (isSelectAll) {
                  checked =
                    requestTypeList.length === REQUEST_TYPE_OPTIONS.length &&
                    REQUEST_TYPE_OPTIONS.length > 0;
                } else {
                  // Explicitly check if this option is in requestTypeList
                  checked = (requestTypeList || []).some(
                    (item) => item.id === option.id,
                  );
                }

                return (
                  <li key={key} {...liProps}>
                    <Checkbox sx={{ mr: 1 }} checked={checked} />
                    {option.label}
                  </li>
                );
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });

                  return (
                    <Chip
                      key={key}
                      label={typeof option === "string" ? option : option.label}
                      {...tagProps}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Request Type*"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                />
              )}
            />
          </Grid>
          {/* Requestor for KO ID */}
          {/* <Grid item xs={12} sm={6} md={4}>
            <TextField
              size="small"
              fullWidth
              label="Requester Ko Id*"
              value={userKoId}
              onChange={(e) => setUserKoId(e.target.value)}
              disabled={!isIBP}
              sx={{ "& .MuiInputBase-root": { height: 37.5 } }}
              InputLabelProps={{
                shrink: true,
                style: { transform: "translate(14px, -14px) scale(0.75)" },
              }}
            />
          </Grid> */}
        </Grid>

        {/* Row 3 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* IBP Role */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              disablePortal
              options={IBPRoleOptions}
              size="small"
              value={IBPRole}
              onChange={ibpRoleOnChangeHandler}
              disabled={!isIBP}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="IBP Business Role*"
                  disabled={!isIBP}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: !isIBP ? "rgba(0,0,0,0.38)" : "rgba(0,0,0,0.87)",
                    },
                  }}
                />
              )}
            />
          </Grid>
          {/* Permission Filter */}
          <Grid item xs={12} sm={6} md={4}>
            {/* <Autocomplete
              multiple
              limitTags={1}
              disablePortal
              options={sortedOptions}
              groupBy={(option) => option.bottler || "Other"}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.roleName
              }
              size="small"
              value={permissionFilter}
              onChange={(e, v) => setPermissionFilter(v ? v.roleName : null)}
              noOptionsText={
                IBPRole ? "No options" : "Select IBP Business Role"
              }
              filterOptions={(options, { inputValue }) => {
                if (!inputValue?.trim()) return options;

                const lower = inputValue.toLowerCase();

                return options.filter(
                  (opt) =>
                    opt.roleName.toLowerCase().includes(lower) ||
                    (opt.bottler && opt.bottler.toLowerCase().includes(lower))
                );
              }}
              isOptionEqualToValue={(option, value) =>
                option.roleName === value
              }
              disabled={!isIBP}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Permission Filter*"
                  disabled={!isIBP}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: !isIBP ? "rgba(0,0,0,0.38)" : "rgba(0,0,0,0.87)",
                    },
                  }}
                />
              )}
              renderGroup={(params) => (
                <li key={params.key}>
                  <div
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#D3D3D3",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    {params.group}
                  </div>
                  <ul style={{ padding: 0, margin: 0 }}>{params.children}</ul>
                </li>
              )}
            /> */}
            <Autocomplete
              multiple
              limitTags={1}
              disableCloseOnSelect
              options={permissionOptionsWithAll}
              groupBy={(option) => option.bottler || "All Option"}
              getOptionLabel={(option) =>
                option.roleName ? option.roleName : ""
              }
              size="small"
              value={permissionFilterList}
              onChange={(e, newValue) => {
                const clickedAll = (newValue || []).some((o) => o.isSelectAll);
                let nextSelected = [];

                if (clickedAll) {
                  const lower = (permissionFilterInput || "")
                    .trim()
                    .toLowerCase();
                  const filtered = lower
                    ? sortedOptions.filter(
                        (opt) =>
                          opt.roleName.toLowerCase().includes(lower) ||
                          (opt.bottler &&
                            opt.bottler.toLowerCase().includes(lower)),
                      )
                    : sortedOptions;

                  const allAlreadySelected =
                    (permissionFilterList || []).length === filtered.length &&
                    filtered.length > 0;

                  nextSelected = allAlreadySelected ? [] : filtered;
                } else {
                  nextSelected = newValue || [];
                }

                setPermissionFilterList(nextSelected);
                if (nextSelected.length === 0) {
                  setPermissionFilter(null);
                } else {
                  setPermissionFilter(nextSelected[0].roleName || null);
                }
              }}
              onInputChange={(e, newInputValue) => {
                setPermissionFilterInput(newInputValue || "");
              }}
              filterOptions={(options, { inputValue }) => {
                const lower = (inputValue || "").toLowerCase().trim();

                const filteredRealOptions = options.filter(
                  (opt) =>
                    !opt.isSelectAll &&
                    (opt.roleName.toLowerCase().includes(lower) ||
                      (opt.bottler &&
                        opt.bottler.toLowerCase().includes(lower))),
                );

                const allOption = options.find((opt) => opt.isSelectAll);
                return allOption
                  ? [allOption, ...filteredRealOptions]
                  : filteredRealOptions;
              }}
              isOptionEqualToValue={(option, value) =>
                option.roleName === value.roleName
              }
              noOptionsText={
                IBPRole ? "No options" : "Select IBP Business Role"
              }
              disabled={!IBPRole}
              renderOption={(props, option, { selected }) => {
                const isSelectAll = !!option.isSelectAll;
                const lower = (permissionFilterInput || "")
                  .trim()
                  .toLowerCase();
                const filteredForRender = lower
                  ? sortedOptions.filter(
                      (opt) =>
                        opt.roleName.toLowerCase().includes(lower) ||
                        (opt.bottler &&
                          opt.bottler.toLowerCase().includes(lower)),
                    )
                  : sortedOptions;

                const checked = isSelectAll
                  ? (permissionFilterList || []).length ===
                      filteredForRender.length && filteredForRender.length > 0
                  : selected;

                return (
                  <li {...props} key={option.roleName}>
                    <Checkbox sx={{ mr: 1 }} checked={checked} />
                    {option.roleName}
                  </li>
                );
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip
                    key={option.roleName}
                    size="small"
                    label={option.roleName}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Permission Filter*"
                  disabled={!IBPRole}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      maxHeight: 90,
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      flexDirection: "row",
                      overflow: "auto",
                      // backgroundColor: disabled ? "#f5f5f5" : "transparent",
                    },
                    "& .MuiAutocomplete-input": {
                      order: -1,
                      minWidth: "100px",
                      flexGrow: 1,
                    },
                    "& .MuiInputLabel-root": {
                      color: !IBPRole ? "rgba(0,0,0,0.38)" : "rgba(0,0,0,0.87)",
                    },
                    "& .MuiChip-root": { order: 0 },
                  }}
                />
              )}
              renderGroup={(params) => (
                <li key={params.key}>
                  <div
                    style={{
                      padding: "8px 16px",
                      backgroundColor: "#D3D3D3",
                      fontWeight: "bold",
                      color: "#000000",
                    }}
                  >
                    {params.group}
                  </div>
                  <ul style={{ padding: 0, margin: 0 }}>{params.children}</ul>
                </li>
              )}
            />
          </Grid>
        </Grid>

        {/* Row 4 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* Bottler */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              limitTags={1}
              options={bottlerOptionsWithAllOptions}
              disableCloseOnSelect
              value={bottlerList}
              onChange={bottlerOnChangeHandler}
              disabled={!isAutonomous}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              renderOption={(props, option, { selected }) => {
                const { key, ...liProps } = props;

                const isSelectAll = option?.isSelectAll === true;

                const checked = isSelectAll
                  ? bottlerList.length === bottlerOptions.length &&
                    bottlerOptions.length > 0
                  : selected;

                return (
                  <li key={key} {...liProps}>
                    <Checkbox sx={{ mr: 1 }} checked={checked} />
                    {option.label}
                  </li>
                );
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });

                  return (
                    <Chip
                      key={key}
                      size="small"
                      label={typeof option === "string" ? option : option.label}
                      {...tagProps}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Bottler*"
                  size="small"
                  disabled={!isAutonomous}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      maxHeight: 95,
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      flexDirection: "row",
                      overflow: "auto",
                      // backgroundColor: disabled ? "#f5f5f5" : "transparent",
                    },
                    "& .MuiAutocomplete-input": {
                      order: -1,
                      minWidth: "100px",
                      flexGrow: 1,
                    },
                    "& .MuiInputLabel-root": {
                      color: !isAutonomous
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.87)",
                    },
                    "& .MuiChip-root": { order: 0 },
                  }}
                />
              )}
            />
          </Grid>
          {/* Country */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              limitTags={1}
              disabled={!isAutonomous}
              options={countryOptionsWithAllOptions}
              disableCloseOnSelect
              value={countryList}
              onChange={countryOnChangeHandler}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              renderOption={(props, option, { selected }) => {
                const { key, ...liProps } = props;

                const isSelectAll = option?.isSelectAll === true;

                const checked = isSelectAll
                  ? countryList.length === countryOptions.length &&
                    countryOptions.length > 0
                  : selected;

                return (
                  <li key={key} {...liProps}>
                    <Checkbox sx={{ mr: 1 }} checked={checked} />
                    {option.label}
                  </li>
                );
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });

                  return (
                    <Chip
                      size="small"
                      key={key}
                      label={typeof option === "string" ? option : option.label}
                      {...tagProps}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Country*"
                  size="small"
                  disabled={!isAutonomous}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      maxHeight: 95,
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      flexDirection: "row",
                      overflow: "auto",
                      // backgroundColor: disabled ? "#f5f5f5" : "transparent",
                    },
                    "& .MuiAutocomplete-input": {
                      order: -1,
                      minWidth: "100px",
                      flexGrow: 1,
                    },
                    "& .MuiInputLabel-root": {
                      color: !isAutonomous
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.87)",
                    },
                    "& .MuiChip-root": { order: 0 },
                  }}
                />
              )}
            />
          </Grid>
          {/* Customer */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              limitTags={1}
              disabled={!isAutonomous}
              options={customerOptionsWithAllOptions}
              disableCloseOnSelect
              value={customerList}
              onChange={customerOnChangeHandler}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              renderOption={(props, option, { selected }) => {
                const { key, ...liProps } = props;

                const isSelectAll = option?.isSelectAll === true;

                const checked = isSelectAll
                  ? customerList.length === customerOptions.length &&
                    customerOptions.length > 0
                  : selected;

                return (
                  <li key={key} {...liProps}>
                    <Checkbox sx={{ mr: 1 }} checked={checked} />
                    {option.label}
                  </li>
                );
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });

                  return (
                    <Chip
                      size="small"
                      key={key}
                      label={typeof option === "string" ? option : option.label}
                      {...tagProps}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Customer*"
                  size="small"
                  disabled={!isAutonomous}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      maxHeight: 95,
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      flexDirection: "row",
                      overflow: "auto",
                      // backgroundColor: disabled ? "#f5f5f5" : "transparent",
                    },
                    "& .MuiAutocomplete-input": {
                      order: -1,
                      minWidth: "100px",
                      flexGrow: 1,
                    },
                    "& .MuiInputLabel-root": {
                      color: !isAutonomous
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.87)",
                    },
                    "& .MuiChip-root": { order: 0 },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Row 5 */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {/* Plant  */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              multiple
              limitTags={1}
              disabled={!isAutonomous}
              options={plantOptionsWithAllOptions}
              disableCloseOnSelect
              value={plantList}
              onChange={plantOnChangeHandler}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              renderOption={(props, option, { selected }) => {
                const { key, ...liProps } = props;

                const isSelectAll = option?.isSelectAll === true;

                const checked = isSelectAll
                  ? plantList.length === plantOptions.length &&
                    plantOptions.length > 0
                  : selected;

                return (
                  <li key={key} {...liProps}>
                    <Checkbox sx={{ mr: 1 }} checked={checked} />
                    {option.label}
                  </li>
                );
              }}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });

                  return (
                    <Chip
                      size="small"
                      key={key}
                      label={typeof option === "string" ? option : option.label}
                      {...tagProps}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Plant*"
                  size="small"
                  disabled={!isAutonomous}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      maxHeight: 95,
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      flexDirection: "row",
                      overflow: "auto",
                      // backgroundColor: disabled ? "#f5f5f5" : "transparent",
                    },
                    "& .MuiAutocomplete-input": {
                      order: -1,
                      minWidth: "100px",
                      flexGrow: 1,
                    },
                    "& .MuiInputLabel-root": {
                      color: !isAutonomous
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.87)",
                    },
                    "& .MuiChip-root": { order: 0 },
                  }}
                />
              )}
            />
          </Grid>
          {/* AD Group Role */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              disablePortal
              options={AD_ROLE_OPTIONS}
              size="small"
              value={adGroupRole}
              disabled={!isAutonomous}
              onChange={(e, v) => setAdGroupRole(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="AD Group Role*"
                  disabled={!isAutonomous}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: !isAutonomous
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.87)",
                    },
                  }}
                />
              )}
            />
          </Grid>
          {/* AD Process Type */}
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              disablePortal
              options={AD_PROCESS_TYPE_OPTIONS}
              size="small"
              disabled={!isAutonomous}
              value={adProcessType}
              onChange={(e, v) => setAdProcessType(v)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="AD Process Type*"
                  disabled={!isAutonomous}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      transform: "translate(14px, -14px) scale(0.75)",
                    },
                  }}
                  sx={{
                    "& .MuiInputLabel-root": {
                      color: !isAutonomous
                        ? "rgba(0,0,0,0.38)"
                        : "rgba(0,0,0,0.87)",
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>

        {/* Submission & clear Button */}
        <Grid container spacing={2} justifyContent="center">
          <Grid item>
            <ButtonComponent
              label="Clear"
              maxWidth="120px"
              bgColor="#808080"
              color="white"
              onClick={handleClear}
              sx={{ mr: 1 }}
            />
          </Grid>
          <Grid item>
            <ButtonComponent
              label={isSubmitting ? "Submitting..." : "Submit"}
              maxWidth="120px"
              bgColor="black"
              color="white"
              onClick={handleSubmit}
              disabled={isSubmitting}
            />
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2} justifyContent="center">
        <Grid item>
          <ButtonComponent
            maxWidth="150px"
            label={loading ? "Processing..." : "Download"}
            bgColor="black"
            color="white"
            disabled={loading}
            startIcon={<DownloadIcon />}
            onClick={DownloadTemplate}
          />
        </Grid>
        <Grid item>
          <ButtonComponent
            label={isUploading ? "Uploading..." : "Bulk Upload"}
            bgColor="black"
            color="white"
            disabled={isUploading}
            onClick={() => {
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
                fileInputRef.current.click();
              }
            }}
            startIcon={<FileUploadIcon />}
          />
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default AccessRequest;
